import * as moment from 'moment';

export const id2date = (id: string): Date | null => {
  if (id) {
    return moment(id, 'YYYYMMDD').toDate();
  } else {
    return null;
  } // else
};
